import config from 'config';

import featureNames from '~/shared/constants/featureFlags';
import { getPromoPricingActiveAsset } from '~/shared/utils/getPromoPricingActiveAsset';
import { getPromoPricingUIAssetContainerName } from '~/shared/utils/promoPricingUI';
import useHasFeature from '~/shared/utils/useHasFeature';
import { useMembership } from '~/techstyle-shared/react-accounts';
import { useAsset } from '~/techstyle-shared/react-assets';

export default function usePromoDisplay({ product }) {
  const { isVip } = useMembership();
  const promoPricingConfig = config.get('public.brand.promoPricingUI');

  const offerLabelContainerName = getPromoPricingUIAssetContainerName(
    promoPricingConfig,
    isVip
  );

  const assetContainerOfferLabel = useAsset(offerLabelContainerName);
  const { enabled: isPrioritizedFeatureEnabled } = useHasFeature(
    featureNames.PRIORITIZED_PROMOS
  );
  const isPrioritizedEnabled =
    isPrioritizedFeatureEnabled && promoPricingConfig?.showPromoPricingOffer;

  const promoPricingActiveAsset = getPromoPricingActiveAsset({
    isPrioritizedEnabled,
    assetContainerOfferLabel,
    product,
  });

  const promoCode = product?.promos?.promoCode;
  const promoLabel = product?.promos?.promoLabel || '';
  const hasPromo = Boolean(promoCode) && typeof promoCode === 'string';
  const gridLabel = promoPricingActiveAsset?.options?.customVars?.gridLabel;

  const htmlText = promoPricingActiveAsset?.options?.htmlText?.trim();

  let offerLabel = htmlText ? `${htmlText}` : null;
  offerLabel =
    offerLabel && gridLabel ? `${offerLabel}${gridLabel}` : offerLabel;

  const shouldShowOfferLabel =
    isPrioritizedEnabled && Boolean(htmlText || gridLabel);

  const shouldShowPromoLabel =
    Boolean(!shouldShowOfferLabel && promoCode && promoLabel) ||
    Boolean(!shouldShowOfferLabel && hasPromo);

  return {
    shouldShowOfferLabel,
    shouldShowPromoLabel,
    offerLabel,
    promoLabel,
    promoCode,
    hasPromo,
    isPrioritizedEnabled,
    assetContainerOfferLabel,
    promoPricingActiveAsset,
  };
}
